import {message} from '@sail/intl';

const messages = {
  somethingWentWrong: message({
    id: 'crypto.payins.something_went_wrong_v2',
    description:
      'Generic error message shown when an unexpected error occurs during the crypto payin flow',
    defaultMessage: 'Something went wrong',
  }),

  error404: message({
    id: 'crypto.payins.error_404_v2',
    description:
      'Error page message shown when the crypto payin link cannot be found (HTTP 404)',
    defaultMessage:
      'Oops! The link you have followed is as missing as Satoshi Nakamoto.',
  }),

  error410: message({
    id: 'crypto.payins.error_410_v2',
    description:
      'Error page message shown when the crypto payin link has expired due to inactivity (HTTP 410)',
    defaultMessage:
      'Oops! This link has expired due to inactivity. Please go back and try again.',
  }),

  testmodeBadgeLabel: message({
    id: 'crypto.payins.testmode_badge_label',

    description:
      'Badge to alert merchants they are in the testmode environment',

    defaultMessage: 'TEST MODE',
  }),

  embeddingNotAllowed: message({
    id: 'crypto.payins.embedding_not_allowed',
    description:
      'Error message shown when the crypto payin page is loaded inside an iframe, which is not permitted',
    defaultMessage:
      'This page cannot be embedded. Open it directly in your browser.',
  }),
};
export default messages;
